var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.locked)?_c('div',{staticClass:"agencies"},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }